import React from 'react';
import StyledContent from './styled';

export default function CustomerChoiceFailedTag({ noteContent }) {
  return (
    <StyledContent>
      <h3>{noteContent}</h3>
    </StyledContent>
  );
}
